import {SharedQuestion} from "./SharedQuestion";

export class ReviewSharedQuestion extends SharedQuestion {

    isValid():boolean {
        super.isValid();

        return true;
    }

    getValue():IValue {
        return null;
    }

    setValue(value:any) {

    }

    satisfiesValue(currentValues:IValue[], node:IValue):boolean {
        return true;
    }

}